import { httpGet, httpDelete, httpPost } from '../http';

export interface AdminSubscription {
  id: number;
  email: string;
  name?: string;
  status: 'active' | 'unsubscribed';
  source: string;
  subscribed_at: string;
  unsubscribed_at?: string;
  created_at: string;
  updated_at: string;
}

export const getAdminSubscriptions = async (status?: string): Promise<AdminSubscription[]> => {
  const url = status ? `/admin/subscriptions?status=${status}` : '/admin/subscriptions';
  const data = await httpGet<AdminSubscription[]>(url);
  return data;
};

export const deleteAdminSubscription = async (id: number): Promise<void> => {
  await httpDelete(`/admin/subscriptions/${id}`);
};

export const sendNewsletter = async (subject: string, content: string): Promise<{history_id: string; recipient_count: number}> => {
  const data = await httpPost<{history_id: string; recipient_count: number}>('/admin/subscriptions/send-newsletter', { subject, content });
  return data;
};

// 邮件发送历史
export interface NewsletterHistory {
  id: string;
  subject: string;
  content: string;
  recipient_count: number;
  success_count: number;
  failed_count: number;
  status: string;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface NewsletterHistoryResponse {
  items: NewsletterHistory[];
  total: number;
  page: number;
  size: number;
}

export const getNewsletterHistory = async (page: number = 1, pageSize: number = 10): Promise<NewsletterHistoryResponse> => {
  const data = await httpGet<NewsletterHistoryResponse>(`/admin/subscriptions/history?page=${page}&pageSize=${pageSize}`);
  return data;
};

export const getNewsletterHistoryById = async (id: string): Promise<NewsletterHistory> => {
  const data = await httpGet<NewsletterHistory>(`/admin/subscriptions/history/${id}`);
  return data;
};
